// File generated automatically, do not modify

import axios, { AxiosResponse } from 'axios';

const paths = {
  postDoctor: 'api/Mapping/Doctor',
  deleteDoctor: 'api/Mapping/Doctor',
  postService: 'api/Mapping/Service',
  deleteService: 'api/Mapping/Service',
};

interface PostDoctorParams {
  docplannerDoctorId?: string;
  docplannerAddressId?: string;
  hisDoctorId?: string;
  hisUnitId?: string;
}

function postDoctor(params: PostDoctorParams): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.postDoctor,
    method: 'post',
    params,
  });
}

interface DeleteDoctorParams {
  docplannerDoctorId?: string;
  docplannerAddressId?: string;
}

function deleteDoctor(params: DeleteDoctorParams): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.deleteDoctor,
    method: 'delete',
    params,
  });
}

interface PostServiceParams {
  docplannerServiceId?: string;
  docplannerAddressServiceId?: string;
  hisServiceId?: string;
}

function postService(params: PostServiceParams): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.postService,
    method: 'post',
    params,
  });
}

interface DeleteServiceParams {
  mappingId?: string;
}

function deleteService(params: DeleteServiceParams): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.deleteService,
    method: 'delete',
    params,
  });
}

export const mappingService = {
  paths,
  postDoctor,
  deleteDoctor,
  postService,
  deleteService,
};
